var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _vm._t(
        "default",
        function () {
          return [
            _vm.canShow
              ? _c(
                  "el-popover",
                  { attrs: { trigger: "hover", placement: "top" } },
                  [
                    _c("el-progress", {
                      staticStyle: { width: "80px" },
                      attrs: {
                        slot: "reference",
                        percentage: _vm.percentage,
                        "show-text": false,
                      },
                      slot: "reference",
                    }),
                    _vm._v(" "),
                    _c("div", { staticClass: "text-center" }, [
                      _c("p", [_vm._v("Total / Left")]),
                      _vm._v(" "),
                      _c("p", [
                        _vm._v(_vm._s(_vm.total) + " / " + _vm._s(_vm.pending)),
                      ]),
                    ]),
                  ],
                  1
                )
              : _vm._e(),
          ]
        },
        null,
        {
          canShow: _vm.canShow,
          percentage: _vm.percentage,
          total: _vm.total,
          pending: _vm.pending,
        }
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }